import React from 'react';

// this component needs
//  -props checked (false or true);
//  -function props onChenge

class SwitchBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  async handleChange() {
    this.props.onChange();
  }

  render() {
    return (
      <div className="switchBtnContainer">
        <label className="custom-toggle">
          <input
            name="checked"
            type="checkbox"
            onChange={this.handleChange}
            checked={this.props.checked}
            disabled={this.props.disabled ? this.props.disabled : false}
          />
          <span className="custom-toggle-slider rounded-circle slide" />

          <i
            className={`icon-check2 ${
              this.props.checked ? 'checkIcon' : 'checkIconHidden'
            }`}
          />
          <i
            className={`icon-close ${
              !this.props.checked ? 'non-checked-icon' : 'checkIconHidden'
            }`}
          />
        </label>
      </div>
    );
  }
}
export default SwitchBtn;
